import axios from "axios";
import ApiGatewayBase from "axios";
import { ChannelIcons } from "./constants";

export function getScheduleHandler(event) {
    event.preventDefault();

    axios.get(ApiGatewayBase + "/schedule-actions", {
      params: {
        channel: "BRAVO-EAST",
      }
    }).then(function (response) {
      console.log(response);
    }).catch(function (error) {
      console.log(error);
    })
  }

export function getVideoPlayerUrl(channel) {
  for (let i = 0; i < ChannelIcons.length; i++) {
    if (ChannelIcons[i].key === channel) {
      return ChannelIcons[i].video_player_url
    }
  }
}

export function getChannelGraphicsUrl(channel) {
  for (const item of ChannelIcons) {
    if (item.key === channel) {
      return item.url;
    }
  }
}
